module.exports = __webpack_public_path__ + "media/src/assets/images/icon-058377018d3b119e25fb8f8389947781.svg";